module.exports = __webpack_public_path__ + "5b7113a32f05dd176ed0c3fc4bed4523.png";